export const idx_data_angle = [];

idx_data_angle.push({
  angle: '---',
});

for (let i = 0; i <= 90; i += 5) {
  idx_data_angle.push({
    angle: i + '',
  });
}
